
import MicroModal from 'micromodal';
MicroModal.init({
 disableScroll: true
});

import Swiper from 'swiper';
import IMask from 'imask';
import axios from 'axios';

import 'swiper/swiper.scss';
import 'simplebar';
import 'simplebar/dist/simplebar.css';


// helpers
const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);


let openMenuElements = document.querySelectorAll('.js-open-main-menu');
let closeMenuElements = document.querySelectorAll('.js-close-main-menu');
let openCallBackPopup = document.querySelectorAll('.js-open-call-back-popup');
let mainPageTabs = document.querySelectorAll('.js-main-tab');
let mainPageTabsContent = document.querySelectorAll('.js-main-tab-content');
let accordionToggle = document.querySelectorAll('.js-accordion-toggle');
let mainPageHeader = $('.js-header-main');
let headerBar = $('.js-header-bar');
let openMonthlyProgress = $$('.js-open-monthly-progress-popup');

openMenuElements.forEach(function (el) {
  el.addEventListener('click', menuOpen);
});

closeMenuElements.forEach(function (el) {
  el.addEventListener('click', menuClose);
});

openCallBackPopup.forEach(function (el) {
  el.addEventListener('click', popupCallBackOpen);
});

mainPageTabs.forEach(function (el) {
  el.addEventListener('click', switchMainPageTabs);
});

accordionToggle.forEach(function (el) {
  el.addEventListener('click', toggleAccordion);
});

// openMonthlyProgress.forEach(function (el) {
//   let month = el.getAttribute('month');
//   el.addEventListener('mouseup', monthProgressPopup(month));
// });

// Обратный звонок
if(document.getElementById('call-back-form')) {
  document.getElementById('call-back-form').addEventListener('submit', submitCallBackForm);
}

// Обратная связь
if (document.getElementById('feedback-form')) {
  document.getElementById('feedback-form').addEventListener('submit', submitFeedbackForm);
}

// Маску на телефоны
document.querySelectorAll('.js-phone-mask').forEach((el) => {
  let imask = IMask(el, {
    mask: '+{7} (000) 000-00-00'
  });

  // При потере фокуса проверить длину
  el.addEventListener('blur', (e) => {

    // +{7} (000) 000-00-00 = 18
    if (e.target.value.length !== 18) {
      e.target.value = '';
    }
  })
});

function  menuClose (event) {
  event.preventDefault();
  document.querySelector('.js-main-menu').classList.add('_hidden');
}

function  menuOpen (event) {
  event.preventDefault();
  document.querySelector('.js-main-menu').classList.remove('_hidden');
}

function  popupCallBackOpen (event) {
  event.preventDefault();
  MicroModal.show('call-back');
}

function submitCallBackForm (event) {
  event.preventDefault();

  const data = {
    name: $('.js-callback-name').value,
    phone: $('.js-callback-phone').value
  };

  axios.post(event.target.getAttribute('action'), data)
    .then(response => {
      MicroModal.close('call-back');
      MicroModal.show('call-back-after');
    });
}

function submitFeedbackForm (event) {
  event.preventDefault();

  const data = {
    name: $('.js-feedback-name').value,
    email: $('.js-feedback-email').value,
    phone: $('.js-feedback-phone').value
  };

  axios.post(event.target.getAttribute('action'), data)
    .then(response => {
      MicroModal.show('call-back-after');
    });
}

function switchMainPageTabs (event) {
  let activeTab = event.target;
  mainPageTabs.forEach(function (el) {
    el.classList.remove('_active');
  });
  activeTab.classList.add('_active');

  mainPageTabsContent.forEach(function (el) {
    el.classList.remove('_active');
  });

  if (activeTab.classList.contains('js-main-tab-1')) {
    document.getElementsByClassName('js-main-tab-content-1')[0].classList.add('_active');
  } else {
    document.getElementsByClassName('js-main-tab-content-2')[0].classList.add('_active');
  }
}

function toggleAccordion (event) {
  if (event.target.classList.contains('_expanded')) {
    event.target.classList.remove('_expanded');
  } else {
    event.target.classList.add('_expanded');
  }
}

function getPicturesForMonthPopup (month) {
  // console.log('popup month ', month);
  return [

  ]
}

//Purchase terms
let mortgageBtn = document.querySelector('.js-mortgage-btn');
let instalmentBtn = document.querySelector('.js-instalment-btn');
let instalmentBlock = document.querySelector('.js-instalment-block');
let mortgageBlock = document.querySelector('.js-mortgage-block');

if (mortgageBtn && instalmentBtn && instalmentBlock && mortgageBlock) {
  mortgageBtn.addEventListener('click', () => {
    instalmentBtn.classList.remove('_active');
    instalmentBlock.classList.add('_hidden');
    mortgageBtn.classList.add('_active');
    mortgageBlock.classList.remove('_hidden');
  })
  instalmentBtn.addEventListener('click', () => {
    instalmentBtn.classList.add('_active');
    instalmentBlock.classList.remove('_hidden');
    mortgageBtn.classList.remove('_active');
    mortgageBlock.classList.add('_hidden');
  })
}


// let sliderMainTop = new Swiper('.slider-main-top', {
//     loop: true,
//     centeredSlides: false,
//     // autoplay: true,
//     // slidesPerView: 3,
//     slidesPerView: 'auto'
//     // spaceBetween: '4rem',
// });

const sliderProgressSettings = {
  loop: false,
  // centeredSlides: false,
  // slidesPerView: 'auto',
  slidesPerView: 'auto',
  spaceBetween: 10,
  // direction: 'vertical',
  watchOverflow: true,
  // preventClicks: false,
  // preventClicksPropagation: false,
  // autoplay: false,
  navigation: {
    prevEl: '.js-slider-month-progress-back',
    nextEl: '.js-slider-month-progress-forward',
  },
  breakpoints: {
    240: {
      direction: 'vertical',
    },
    320: {
      direction: 'vertical',
    },
    1024: {
      direction: 'horizontal',
    },
    1366: {
      direction: 'horizontal',
    }
  },
  observer: true,
  observeParents: true
};

let sliderProgressPopup;
if (document.querySelectorAll('.js-slider-month-progress').length){
  sliderProgressPopup = new Swiper('.js-slider-month-progress', sliderProgressSettings);
}

let sliderFinishingElem = document.querySelector('.js-sliderFinishing');

if (document.querySelectorAll('.js-sliderFinishing').length){
  let sliderFinishing = new Swiper('.js-sliderFinishing', {
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 10,
    watchOverflow: true,
    navigation: {
      prevEl: '.js-sliderFinishingBack',
      nextEl: '.js-sliderFinishingForward',
    },
    observer: true,
    observeParents: true
  });

  sliderFinishingElem.classList.add('is_load');
}

if (document.querySelectorAll('.js-slider-work-progress').length){
        // document.addEventListener("sliderMarginTop", function(event) { // (1)
        //   document.querySelectorAll(".month-progress-gallery__slide").forEach((item)=>{
        //     var elemHeight  = item && item.clientHeight || 0;
        //     var elemnetChild = item.querySelector('img') || 0;
        //     if(elemnetChild!==0){ elemnetChild.style.marginTop = 0+'px'};
        //     var elemImgHeight  = elemnetChild && elemnetChild.clientHeight || 0;
        //     console.log(`
        //      elemHeight = ${elemHeight}
        //      elemImgHeight = ${elemImgHeight}
        //     `);
        //     var mT = 0
        //     if(elemHeight!==0 && elemImgHeight!==0 && elemHeight>elemImgHeight){
        //         elemHeight>elemImgHeight ? mT = elemHeight - elemImgHeight  : mT = 0
        //         elemnetChild.style.marginTop = mT+'px';
        //     }

        //     console.log('mT = ',mT);

        //     });
        //   console.log('sliderMarginTop');
        // });
  let sliderWorkProgress = new Swiper('.js-slider-work-progress', {
    loop: false,
    centeredSlides: true,
    slidesPerView: 'auto',
    navigation: {
      prevEl: '.js-slider-work-progress-back',
      nextEl: '.js-slider-work-progress-forward',
    },
    breakpoints: {
      1024: {
        centeredSlides: false,
      }
    },
    on: {
      click: function (event) {
        let slide = event.clickedSlide;
        if (!slide) return;

        let slides = [];

        let title = slide.dataset.title;
        let images = JSON.parse(slide.dataset.images);

        let titleNode = document.getElementById('month-progress-gallery__title-id');

        titleNode.textContent = title;

        sliderProgressPopup.destroy();

        let sliderWrapper = document.getElementById('slider-month-progress-container');
        sliderWrapper.innerHTML = "";

        for (let i in images) {
          const elem = document.createElement('div');
          elem.classList.add('swiper-slide', 'month-progress-gallery__slide');
          elem.innerHTML = `<picture>
                        <source media="(min-width: 1024px)" srcset="/storage/${images[i]} 1x, /storage/${images[i]} 2x" onload="document.dispatchEvent(new CustomEvent('sliderMonthProgressUpdate'))">
                        <img src="/storage/${images[i]}" srcset="/storage/${images[i]} 2x" onload=" document.dispatchEvent(new CustomEvent('sliderMonthProgressUpdate'))" alt="">
                    </picture>
                      <span class="slide-number">${parseInt(i) + 1}</span>`;
          sliderWrapper.appendChild(elem);
        }

        sliderProgressPopup = new Swiper('.js-slider-month-progress', sliderProgressSettings);

        document.addEventListener("sliderMonthProgressUpdate", function(event) { // (1)
          sliderProgressPopup.update();
          console.log('sliderMonthProgressUpdate');
        });
        document.dispatchEvent(new CustomEvent("sliderMonthProgressUpdate"));

        // document.addEventListener("sliderMarginTop", function(event) { // (1)
        //   document.querySelectorAll(".month-progress-gallery__slide").forEach((item)=>{
        //     var elemHeight  = item && item.clientHeight || 0;
        //     var elemnetChild = item.querySelector('img') || 0;
        //     if(elemnetChild!==0){ elemnetChild.style.marginTop = 0+'px'};
        //     var elemImgHeight  = elemnetChild && elemnetChild.clientHeight || 0;
        //     console.log(`
        //      elemHeight = ${elemHeight}
        //      elemImgHeight = ${elemImgHeight}
        //     `);
        //     var mT = 0
        //     if(elemHeight!==0 && elemImgHeight!==0 && elemHeight>elemImgHeight){
        //         elemHeight>elemImgHeight ? mT = elemHeight - elemImgHeight  : mT = 0
        //         elemnetChild.style.marginTop = mT+'px';
        //     }

        //     console.log('mT = ',mT);

        //     });
        //   console.log('sliderMarginTop');
        // });
        // document.dispatchEvent(new CustomEvent("sliderMarginTop"));


        MicroModal.show('month-progress', {
          disableScroll: true,
          onShow: (modal) => {
            sliderProgressPopup.update();
            setTimeout(() => {
              sliderProgressPopup.update();
            }, 200);
          },
        });
        sliderProgressPopup.update();
      },
      // slideChange: function (event) {
      //   console.log('slide changed');
      //   // document.dispatchEvent(new CustomEvent("sliderMarginTop"));
      // },
      // resize: function(event) {
      //   // document.dispatchEvent(new CustomEvent("sliderMarginTop"));
      // }
    }
  });
}

if (document.querySelectorAll('.js-slider-parking').length){
  let sliderParking = new Swiper('.js-slider-parking', {
    loop: false,
    centeredSlides: true,
    slidesPerView: 1,
    navigation: {
      prevEl: '.js-slider-parking-back',
      nextEl: '.js-slider-parking-forward',
    }
  });
}

// const sliderFinishing =  document.querySelector('.js-sliderFinishing');

// document.addEventListener("DOMContentLoaded", function(event) {
//   if (typeof(sliderFinishing) != 'undefined' && sliderFinishing != null) {
//     sliderFinishing.classList.add('is_load')
//   }
// });

if (document.querySelectorAll('.js-slider-special').length){
  let sliderSpecial = new Swiper('.js-slider-special', {
    loop: false,
    centeredSlides: false,
    slidesPerView: 1,
    navigation: {
      prevEl: '.js-slider-gallery-back',
      nextEl: '.js-slider-gallery-forward',
    }
  });
}

if (document.querySelectorAll('.js-slider-news').length){
  let sliderNews = new Swiper('.js-slider-news', {
    loop: false,
    centeredSlides: false,
    slidesPerView: 'auto',
    navigation: {
      prevEl: '.js-slider-gallery-back',
      nextEl: '.js-slider-gallery-forward',
    },
  });
}

document.addEventListener("DOMContentLoaded", function(event) {
  let sliderGallery;
  if (document.querySelectorAll('.js-slider-gallery').length){

    // let sliderGallery = new Swiper('.js-slider-gallery', {
    // sliderGallery = new Swiper('.js-slider-gallery', {
    //   // init: false,
    //     loop: true,
    //     slidesPerView: 'auto',
    //     // loopedSlides: 4,
    //     loopedSlides: document.querySelectorAll('.js-slider-gallery').length,
    //     loopPreventsSlide: false,
    //     centeredSlides: true,

    //     // freeMode: true,
    //     // loopFillGroupWithBlank: true,
    //     speed: 36000,
    //     // allowTouchMove: true,
    //     // observer: true,
    //     autoplay: {
    //       // delay: 1000,
    //       delay: 0,
    //       // disableOnInteraction: false,
    //       disableOnInteraction: true,
    //     },

    //     breakpoints: {
    //         1024: {
    //             centeredSlides: false,
    //         }
    //     }
    // });

    sliderGallery = new Swiper('.js-slider-gallery', {
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: true,
        // freeMode: true,
        speed: 700,
        observeParents: true,
        observeSlideChildren: true,
        observer: true,
        navigation: {
            prevEl: '.js-slider-gallery-custom-prev',
            nextEl: '.js-slider-gallery-custom-next',
        },
    });

    let customPrev = document.querySelectorAll('.js-slider-gallery-custom-prev123');
    let customNext = document.querySelectorAll('.js-slider-gallery-custom-next123');
    if(customPrev.length){
      customPrev.forEach(function(item,index){
        item.addEventListener('click', function(e){
          console.log('item',item);
          console.log('index',index);
          sliderGallery.slidePrev(500,true);
          console.log('slidePrev');
        });
      });
    }
    if(customNext.length){
      customNext.forEach(function(item,index){
        item.addEventListener('click', function(e){
          // sliderGallery.autoplay.stop();
          sliderGallery.slideNext(600,true);
          // sliderGallery.autoplay.start();
          console.log('slideNext');
        });
      });
    }
  }

  let exteriorBtn = document.querySelector('.js-gallery-exterior-btn');
  let viewsBtn = document.querySelector('.js-gallery-views-btn');
  let exteriorPics = document.querySelectorAll('.js-gallery-exterior-block');
  let viewsPics = document.querySelectorAll('.js-gallery-views-block');
  let noFilterPics = document.querySelectorAll('.js-gallery-no-filter-block');
  let sliderGalleryLength = document.querySelectorAll('.js-slider-gallery').length;

  console.log('sliderGallery = ',sliderGallery);
  if (exteriorBtn && viewsBtn && exteriorPics && viewsPics) {
    exteriorBtn.addEventListener('click',() => {
      if (!exteriorBtn.classList.contains('_active')) {
        exteriorBtn.classList.add('_active');
        viewsBtn.classList.remove('_active');
        exteriorPics.forEach(pic => pic.classList.remove('_hidden'))
        viewsPics.forEach(pic => pic.classList.add('_hidden'));
        noFilterPics.forEach(pic => pic.classList.add('_hidden'));
        if(sliderGalleryLength){
          sliderGallery.slideTo(0,1);
          sliderGallery.update();
        }
      } else {
        noFilterPics.forEach(pic => pic.classList.remove('_hidden'));
        exteriorPics.forEach(pic => pic.classList.add('_hidden'))
        exteriorBtn.classList.remove('_active');
        if(sliderGalleryLength){
          sliderGallery.slideTo(0,1);
          sliderGallery.update();
        }
      }
    })

    viewsBtn.addEventListener('click',() => {
      if (!viewsBtn.classList.contains('_active')) {
        viewsBtn.classList.add('_active');
        exteriorBtn.classList.remove('_active');
        viewsPics.forEach(pic => pic.classList.remove('_hidden'));
        noFilterPics.forEach(pic => pic.classList.add('_hidden'));
        exteriorPics.forEach(pic => pic.classList.add('_hidden'));
        if(sliderGalleryLength){
          sliderGallery.slideTo(0,1);
          sliderGallery.update();
        }
      } else {
        noFilterPics.forEach(pic => pic.classList.remove('_hidden'));
        viewsPics.forEach(pic => pic.classList.add('_hidden'));
        viewsBtn.classList.remove('_active');
        if(sliderGalleryLength){
          sliderGallery.slideTo(0,1);
          sliderGallery.update();
        }
      }
    })
  }
});


window.onload = function() {
  let hash = location.hash.replace('#','');

  if (hash !== '' && document.getElementById(hash) !== null){
    console.log('scrollIntoView window.onload END__offset = ',document.getElementById(hash).offsetTop)
    // document.getElementById(hash).scrollIntoView({
    //   // behavior: 'smooth'
    //   block: "start", inline: "nearest"
    // });
    setTimeout(()=>{
      window.scrollTo(0,document.getElementById(hash).offsetTop)
    })
  }
}

document.querySelectorAll('.js-menu-anchor').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    document.querySelector('.js-main-menu').classList.add('_hidden');

    if (location.pathname === '/') {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
});

// анимированная карусель сверху на главной

if (mainPageHeader && window.location.hash[0]!=="#") {
  document.addEventListener("DOMContentLoaded", () => {

    /*
    Если страница перезагружается, и ранее она была проскроллена не дальше блока .js-last-object-to-scrollTop - перед загрузкой прокрутить страницу наверх
     */
    if (window.pageYOffset < $('.js-last-object-to-scrollTop').offsetTop) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      document.body.style.position = 'fixed';
      document.body.style.top = '0';
    }

    animateMainHeader();
    console.log('animate');
  });
} else if (mainPageHeader && window.location.hash[0]==="#") {
  document.addEventListener("DOMContentLoaded", () => {
    onStaticMainHeader();

  });

}

var checkScrollSpeed = (function(settings) {
  settings = settings || {};

  var lastPos, newPos, timer, delta,
    delay = settings.delay || 50; // in "ms" (higher means lower fidelity )

  function clear() {
    lastPos = null;
    delta = 0;
  }

  clear();

  return function() {
    newPos = window.scrollY;
    if ( lastPos != null ){ // && newPos < maxScroll
      delta = newPos -  lastPos;
    }
    lastPos = newPos;
    clearTimeout(timer);
    timer = setTimeout(clear, delay);
    return delta;
  };
})();

// function goAnchor() {
//   console.log('goAnchor');
//   if (window.location.hash[0]==="#" && document.querySelectorAll(window.location.hash).length){
//     if(window.scrollY < document.querySelector(window.location.hash).offsetTop) {
//       window.scroll({
//         top: document.querySelector(window.location.hash).offsetTop,
//         left: 0,
//         behavior: 'smooth'
//       });
//     }
//   }
//   console.log('step_3');
// }

function animateMainHeader() {
  console.log('animateMainHeader');
  let ul1 = $('.js-pics-animate-kit');

  document.documentElement.style.overflowX = 'hidden';

  setTimeout(function() {
    ul1.classList.add('slides-move-left');
  }, 400);


  if (window.outerWidth >= 1024) {
    setTimeout(function() {
      $('.js-header-main').classList.add('expanded');
      ul1.classList.add('expanded');
    }, 1000);

    setTimeout(function() {
      ul1.classList.remove('expanded');
    }, 1500);

    setTimeout(function() {
      $('.js-slider-wrapper-all').classList.add('animate');
      ul1.classList.remove('absolute-items');

      if ($('.js-pics-2nd-kit')) {
        $('.js-pics-2nd-kit').classList.remove('_hidden');
      }

      $('.js-slider-wrapper-all').parentNode.style.overflow = 'hidden';
      document.body.style.position = 'initial';
      document.documentElement.style.overflowX = 'initial';
      // document.dispatchEvent(new CustomEvent('runSnow'));
      // goAnchor();
    }, 2000);

//    setTimeout(function() {
//      sliderGallery.init()
//    }, 2100);

  } else {
    setTimeout(function() {
      $('.js-header-main').classList.add('expanded');
    }, 800);

    setTimeout(function() {
      $('.js-slider-wrapper-all').classList.add('animate');
      ul1.classList.remove('absolute-items');
      if ($('.js-pics-2nd-kit')) {
        $('.js-pics-2nd-kit').classList.remove('_hidden');
      }
      $('.js-slider-wrapper-all').parentNode.style.overflow = 'hidden';
      document.body.style.position = 'initial';
      document.documentElement.style.overflowX = 'initial';
      // goAnchor();
      // document.dispatchEvent(new CustomEvent('runSnow'));
    }, 1600);

    // setTimeout(function () {sliderGallery.init();}, 1650);
  }

  // sliderGallery.init();
  console.log('animateMainHeader END');
}

function onStaticMainHeader() {
  console.log('onStaticMainHeader');
  let ul1 = $('.js-pics-animate-kit');
  ul1.classList.add('slides-move-left');
  if (window.outerWidth >= 1024) {
      $('.js-header-main').classList.add('expanded');
      $('.js-slider-wrapper-all').classList.add('animate');
      ul1.classList.remove('absolute-items');
      if ($('.js-pics-2nd-kit')) {
        $('.js-pics-2nd-kit').classList.remove('_hidden');
      }
      $('.js-slider-wrapper-all').parentNode.style.overflow = 'hidden';
      document.body.style.position = 'initial';
  } else {
    $('.js-header-main').classList.add('expanded');
    $('.js-slider-wrapper-all').classList.add('animate');
    ul1.classList.remove('absolute-items');
    if ($('.js-pics-2nd-kit')) {
      $('.js-pics-2nd-kit').classList.remove('_hidden');
    }
    $('.js-slider-wrapper-all').parentNode.style.overflow = 'hidden';
  }

  let hash2 = location.hash.replace('#','');
  if (hash2 !== '' && document.getElementById(hash2) !== null){
    // console.log('scrollIntoView onStaticMainHeader END')
    console.log('scrollIntoView onStaticMainHeader END__offset = ',document.getElementById(hash2).offsetTop)
    window.scrollTo(0,document.getElementById(hash2).offsetTop)
    // document.getElementById(hash2).scrollIntoView({
    //   // behavior: 'smooth'
    //   block: "start", inline: "nearest"
    // });
  }

  console.log('onStaticMainHeader END');
  // sliderGallery.init();
}

// паралакс на главной
let parallaxImg = $('.js-main-parallax');

if (parallaxImg) {
  let moveValue = 0.09;
  document.addEventListener('scroll', function() {
    let scrolled = window.pageYOffset;
    // parallaxImg.style.transform = 'translateY(-' + scrolled * moveValue + 'px)';
    parallaxImg.style.transform = 'translateY(-' + scrolled * moveValue + 'px) translateZ(0)';
  })
}

//закреп меню

// if (headerBar) {
//   document.addEventListener('scroll', function () {
//     if (window.pageYOffset > $('body').offsetTop + 5) {
//       headerBar.classList.add('fixed');
//     } else {
//       headerBar.classList.remove('fixed');
//     }
//   })
// }

//mortgage-calculator
if ($$('.input-item__wrapper input')[1]) {
  setTimeout(() => {
    let percentageBlock = document.createElement('div');
    percentageBlock.classList.add('percent');
    let mortgageSliderBlocks = $$('.input-item__wrapper');
    let mortgageInputs = $$('.input-item__wrapper input');
    let mortgageSliderHandles = $$('.noUi-handle');
    if (mortgageSliderBlocks) {
      percentageBlock.style.position= 'absolute';
      percentageBlock.style.right= '0px';
      if (parseInt(mortgageInputs[1].value,10) !== 0) {
        percentageBlock.innerHTML = Math.round(parseInt(mortgageInputs[2].value,10) / parseInt(mortgageInputs[1].value,10) * 100) + '%';
      } else {
        percentageBlock.innerHTML = '0%';
      }
      mortgageSliderBlocks[2].appendChild(percentageBlock)
    }
    let sliders = document.querySelectorAll('.range');
    if (sliders) {
      mortgageInputs[1].addEventListener('input',() => {
        if (parseInt(mortgageInputs[1].value,10) !== 0) {
          percentageBlock.innerHTML = Math.round(parseInt(mortgageInputs[2].value,10) / parseInt(mortgageInputs[1].value,10) * 100) + '%';
        } else {
          percentageBlock.innerHTML = '0%';
        }
      })
      mortgageInputs[2].addEventListener('input',() => {
        if (parseInt(mortgageInputs[1].value,10) !== 0) {
          percentageBlock.innerHTML = Math.round(parseInt(mortgageInputs[2].value,10) / parseInt(mortgageInputs[1].value,10) * 100) + '%';
        } else {
          percentageBlock.innerHTML = '0%';
        }
      })
      sliders[1].noUiSlider.on('slide', () => {
        if (parseInt(mortgageInputs[1].value,10) !== 0) {
          percentageBlock.innerHTML = Math.round(parseInt(mortgageInputs[2].value,10) / parseInt(mortgageInputs[1].value,10) * 100) + '%';
        } else {
          percentageBlock.innerHTML = '0%';
        }
      });
      sliders[2].noUiSlider.on('slide', () => {
        if (parseInt(mortgageInputs[1].value,10) !== 0) {
          percentageBlock.innerHTML = Math.round(parseInt(mortgageInputs[2].value,10) / parseInt(mortgageInputs[1].value,10) * 100) + '%';
        } else {
          percentageBlock.innerHTML = '0%';
        }
      });
    }

    let resetCalculator = document.querySelector('.js-calculator-reset');

    if (resetCalculator) {
      resetCalculator.addEventListener('click',() => {
        sliders.forEach(slider => {
          slider.noUiSlider.reset();
          mortgageInputs[0].value = Math.floor(mortgageSliderHandles[0]['ariaValueText']);
          mortgageInputs[1].value = Math.floor(mortgageSliderHandles[1]['ariaValueText']);
          mortgageInputs[2].value = Math.floor(mortgageSliderHandles[2]['ariaValueText']);
          mortgageInputs[3].value = Math.floor(mortgageSliderHandles[3]['ariaValueText']);
          percentageBlock.innerHTML = Math.round(parseInt(mortgageSliderHandles[2]['ariaValueText'],10) / parseInt(mortgageSliderHandles[1]['ariaValueText'],10) * 100) + '%';
        })
      });
    }

  },300)
}
